<script setup lang="ts">
    import SettingsPageLayout from '../components/settings/SettingsPageLayout.vue';
    import { __ } from '../stores/expressions';
    import EchoButton from '../components/EchoButton.vue';
    import RolesList from '../components/roles/RolesList.vue';
    import { usePermissions } from '@/js/composables/usePermissions';
    import { PermissionArea, RoleManagementPermissionFlag } from '@/js/consts/permissions';
    import { PlusIcon } from '@lucide/vue';

    const { hasPermission } = usePermissions();

    const canCreateRole = hasPermission(
        PermissionArea.RoleManagement,
        RoleManagementPermissionFlag.Access
    );
</script>

<template>
    <SettingsPageLayout fill-table>
        <template #header>
            <h1 class="heading-lg-light">{{ __('settings-manage-roles') }}</h1>
            <p class="text-body">
                {{ __('manage-roles-subtitle') }}
            </p>
        </template>
        <template #topbar>
            <EchoButton v-if="canCreateRole" variant="primary" route="/settings/manage-roles/new">
                {{ __('manage-roles-add-new-role') }}
                <template #icon-right><PlusIcon /></template>
            </EchoButton>
        </template>
        <template #content>
            <RolesList />
        </template>
    </SettingsPageLayout>
</template>
